import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Add as AddIcon } from '@mui/icons-material';
import { Loader, Text, Button, SearchBar, Theme, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';

import Header from '../../components/Header.js';
import AdvisorCard from '../../components/Cards/AdvisorCard.js';
import { getAdvisors } from '../../actions/advisors.js';
import AdvisorForm from '../../components/AdvisorForm.js';
import BrokerageForm from '../../components/BrokerageForm.js';
import permissionLevel from '../../services/permissions.js';
import PermissionsComponent from '../../components/PermissionsComponent.js';

class AdvisorList extends PureComponent {
    state = {
        query: '',
        showNewAdvisor: false
    };

    static getDerivedStateFromProps(props) {
        if (!permissionLevel('Advisors', props.accessType).includes('read')) {
            window.location.href = '/403';
        }

        return null;
    }

    componentDidMount() {
        if (!this.props.advisors) {
            this.props.dispatch(getAdvisors(this.state.query, 0));
        }
    }

    _toggleShowBrokerage = () => {
        this.setState({
            showNewBrokerage: !this.state.showNewBrokerage
        });
    };

    _toggleShowAdvisor = () => {
        this.setState({
            showNewAdvisor: !this.state.showNewAdvisor
        });
    };

    // submit a new search, we must reset the cursor
    _search = () => {
        this.props.dispatch(getAdvisors(this.state.query, 0));
    };

    _handleInputChange = (type, event) => {
        this.setState({
            [type]: event.target.value
        });
    };

    _loadMore = () => {
        this.props.dispatch(getAdvisors(this.state.query, false));
    };

    render() {
        if (!this.props.advisors) {
            return <Loader />;
        }

        return (
            <ContainerControlSite background={"true"}>
                <Header
                    subHeader="Advisors"
                    selectedTitle="advisors"
                />

                <Content>
                    <PermissionsComponent
                        permission="Advisors"
                        accessType={this.props.accessType}
                        level="write"
                    >
                        <div style={{ marginLeft: 'auto' }}>
                            <Button
                                testid="add-brokerage"
                                transparent
                                onClick={this._toggleShowBrokerage}
                                customStyle={{ marginLeft: 'auto' }}
                            >
                                <AddIcon style={{ lineHeight: '21px', color: 'inherit' }} />&nbsp;Brokerage
                            </Button>
                            <Button
                                testid="add-advisor"
                                transparent
                                onClick={this._toggleShowAdvisor}
                                customStyle={{ marginLeft: 'auto' }}
                            >
                                <AddIcon style={{ lineHeight: '21px', color: 'inherit' }} />&nbsp;Advisor
                            </Button>
                        </div>
                    </PermissionsComponent>

                    <SearchBar
                        onChange={(value) => this._handleInputChange('query', value)}
                        search={this._search}
                        placeholder="Search..."
                        iconColor={Theme.colors.skyBlue}
                        customStyle={{
                            margin: '20px auto',
                            width: '100%',
                            backgroundColor: Theme.colors.surface
                        }}
                    />

                    {
                        this.props.advisors.length > -1 && this.props.advisors.map((advisor, i) => (
                            <Link key={advisor.advisorID} to={`/advisors/${ advisor.advisorID }`} style={{ textDecoration: 'none' }}>
                                <AdvisorCard testid={i === 0 ? 'advisor-card' : undefined} advisor={advisor} />
                            </Link>
                        ))
                    }

                    {
                        this.props.advisors.length === 0 &&
                        <Text
                            align="center"
                            mediumLarge
                            display="block"
                        >
                            No results to display
                        </Text>
                    }

                    {
                        this.props.cursor >= 0 &&
                        <Button
                            onClick={this._loadMore}
                            color="primary"
                            marginTop={2}
                            fullWidth
                        >
                            Load More
                        </Button>
                    }

                    {
                        this.state.showNewAdvisor &&
                            <AdvisorForm
                                close={this._toggleShowAdvisor}
                            />
                    }

                    {
                        this.state.showNewBrokerage &&
                            <BrokerageForm
                                close={this._toggleShowBrokerage}
                            />
                    }
                </Content>
                <span id="advisors" />
            </ContainerControlSite>
        );
    }
}

AdvisorList.propTypes = {
    advisors: PropTypes.array,
    accessType: PropTypes.string
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    advisors: state.advisors.list,
    cursor: state.advisors.cursor,
    accessType: state.master.access
});

export default connect(mapStateToProps)(AdvisorList);